import React, { useState, useContext } from "react";
import { Box, Button } from "@mui/material";
import { useDimensions } from "src/utils/useDimensions.js";
import BottomDialog from "../../blocks/dialogs/BottomDialog.js";
import CenterDialog from "../../blocks/dialogs/CenterDialog.js";
import StepsScreenContent from "../../instructions/StepsScreenContent.js";
import { UpgradeConsumerButton } from "./UpgradeConsumerButton.js";
import { AuthContext } from "src/utils/AuthContext.js";
import { customEvent } from "src/utils/gtag.js";
import { getPageRoute } from "src/services/Config.js";

const HowTrialWorks = ({ calendar, sx, ...props }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { isSmallScreen } = useDimensions();
  const { user } = useContext(AuthContext);

  const handleOpenDialog = () => {
    setDialogOpen(true);
    customEvent({
      name: "user_click_how_trial_works",
      category: "TrialExplanation",
      label: "How Trial Works Button Click",
      data: {
        user_id: user?._id,
        user_email: user?.email,
      },
    });
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleStartTrial = () => {
    setDialogOpen(false);
    // Let UpgradeConsumerButton handle the upgrade flow
  };

  const steps = [
    {
      icon: "lock_open",
      title: "Today",
      description: "Unlock access to all premium features",
    },
    {
      icon: "notifications",
      title: "Day 5", 
      description: "Get a reminder that your trial is about to end",
    },
    {
      icon: "star",
      title: "Day 7",
      description: "Your subscription starts. Cancel anytime before.",
    },
  ];

  const DialogContent = () => (
    <Box sx={{ p: 2 }}>
      <StepsScreenContent title="How the Free Trial Works" steps={steps}>
        <UpgradeConsumerButton
          size="grown"
          variant="contained"
          color="primary"
          sx={{ width: "100%", mt: -4 }}
          state={{ calendar, source: "how_trial_works" }}
          successUrl={getPageRoute("help", "CALENDAR_CONNECTED")}
          data-upgrade-button="how-trial-works"
        >
          Start Trial Now
        </UpgradeConsumerButton>
      </StepsScreenContent>
    </Box>
  );

  return (
    <>
      {/* How Trial Works Button */}
      <Button
        variant="outlined"
        onClick={handleOpenDialog}
        sx={{
          width: "100%",
          ...sx,
        }}
        {...props}
      >
        How The Trial Works
      </Button>

      {/* Dialog */}
      {isSmallScreen ? (
        <BottomDialog
          open={dialogOpen}
          handleClose={handleCloseDialog}
          hideCloseButton={false}
          hideRectangle={false}
          sx={{ height: "85vh" }}
        >
          <DialogContent />
        </BottomDialog>
      ) : (
        <CenterDialog
          open={dialogOpen}
          handleClose={handleCloseDialog}
          sx={{ 
            ".MuiPaper-root": { 
              maxWidth: "440px",
              borderRadius: "16px",
            } 
          }}
          hideCloseButton={false}
        >
          <DialogContent />
        </CenterDialog>
      )}
    </>
  );
};

export default HowTrialWorks;